import React, { useState, useEffect } from "react";

const DynamicImport = (props) => {
    const { name, importComponent } = props;
    const [ Component, setComponent ] = useState(null);

    useEffect(() => {
        if (Component) {
            return;
        }

        importComponent().then(({ default: ImportedComponent }) => {
            setComponent((
                <ImportedComponent { ...props } />
            ));
        }).catch((error) => console.log(`An error occurred while loading the ${ name } component: `, error));
    }, [ importComponent, Component, setComponent, name, props ]);

    if (!Component) {
        return null;
    }

    return Component;
};

export default DynamicImport;
